<template>
  <button class="v-checkbox" :checked="checked" :part="part?'':false" @click="toggle()" ref="input">
    <div class="v-checkbox-inner">
      <slot name="checked" v-if="'checked' in $slots"/>
      <v-icon type="v-icon-checkbox-checked" v-else/>
    </div>
    <div class="v-checkbox-label" v-if="label||'default' in $slots">
      <v-text>{{label}}</v-text>
      <slot/>
    </div>
  </button>
</template>

<script>
export default {
  model: {
    prop: "selected"
  },
  props: {
    selected: {
      default() {
        return [];
      }
    },
    label: {
      default: null
    },
    value: {
      default: null
    },
    selectKey: {
      default: null
    }
  },
  data() {
    return {
      parent: null,
      children: []
    };
  },
  computed: {
    key() {
      return this.selectKey || this.$parent.selectKey;
    },
    hasParent() {
      return this.$parent.$options._componentTag == "v-checkbox-group";
    },
    list() {
      return this.hasParent ? this.$parent.selected : this.selected;
    },
    checked() {
      return this.indexOf(this.value) != -1;
    },
    part() {
      let total = this.children.length,
        length = this.children.filter(o => o.checked).length,
        part = this.children.filter(o => o.part).length;
      return (total && part) || (length && length < total);
    }
  },
  watch: {
    ["children.length"](a, b) {
      if (a > b) {
        this.children.forEach(o => {
          o.parent || ((o.parent = this), o.toggleParent());
        });
      }
    }
  },
  methods: {
    indexOf(value) {
      let { list, key } = this;
      value = key ? value[key] : value;
      return list.reduce(
        (p, o, i) =>
          (key && o instanceof Object ? o[key] : o) === value ? i : p,
        -1
      );
    },
    relate(children = []) {
      (this.children = children).forEach(o => (o.parent = this));
    },
    change(list = []) {
      if (this.hasParent) {
        this.$parent.selected = list;
      } else {
        this.$emit("input", list);
        this.$emit("change", this);
      }
    },
    remove() {
      this.clear();
      let index = this.parent.children.indexOf(this);
      index == -1 || this.parent.children.splice(index, 1);
    },
    clear() {
      let list = this.list,
        index = list.indexOf(this.value);
      index == -1 || list.splice(index, 1);
      this.change(list);
    },
    toggle(e) {
      if (this.$attrs.disabled == null) {
        let list = this.list,
          index = this.indexOf(this.value);
        index == -1 ? list.push(this.value) : list.splice(index, 1);
        this.change(list);
        e == 1 || this.toggleParent();
        e == -1 || this.toggleChildren();
      }
    },
    toggleParent() {
      if (this.parent) {
        this.parent.children.reduce((p, o) => {
          return p && (this == o ? this.list.includes(this.value) : o.checked);
        }, true) == this.parent.checked ||
          (this.parent.children.length && this.parent.toggle(-1));
      }
    },
    toggleChildren() {
      this.children.forEach(o => {
        o.checked == this.list.includes(this.value) || o.toggle(1);
      });
    }
  },
  mounted() {
    let index = this.indexOf(this.value);
    if (this.key && index > -1) {
      this.list.splice(index, 1, this.value);
      this.change(this.list);
    }
  },
  destroyed() {
    if (this.parent) {
      this.remove(), this.toggleParent();
    }
  }
};
</script>

<style lang="less">
.v-checkbox {
  border: none;
  padding: 0px;
  outline: none;
  cursor: pointer;
  line-height: 18px;
  font-size: inherit;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  &:hover {
    > .v-checkbox-inner {
      border-color: #41b883;
    }
  }
  > .v-checkbox-inner {
    width: 14px;
    height: 14px;
    line-height: 14px;
    border-radius: 4px;
    display: inline-block;
    vertical-align: middle;
    border: 2px solid #cccccc;
    background-color: #ffffff;
    > * {
      opacity: 0;
      content: "";
      width: 100%;
      height: 100%;
      display: block;
      color: #ffffff;
      visibility: hidden;
      border-radius: 50%;
      background-color: transparent;
      transform: scale(0);
      transition: 300ms;
      &::before {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  > .v-checkbox-label {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
  }
  &[part] {
    > .v-checkbox-inner {
      width: 14px;
      height: 14px;
      border-color: #41b883;
      > * {
        opacity: 1;
        font-size: 14px;
        color: #41b883;
        border-radius: 2px;
        visibility: visible;
        transform: scale(0.7);
        background-color: #41b883;
      }
    }
  }
  &[checked] {
    > .v-checkbox-inner {
      width: 16px;
      height: 16px;
      border-width: 1px;
      border-color: #41b883;
      > * {
        opacity: 1;
        font-size: 16px;
        border-radius: 2px;
        transform: scale(1);
        visibility: visible;
        background-color: #41b883;
      }
    }
  }
  &[disabled] {
    cursor: no-drop;
    color: #cccccc;
    filter: grayscale(100%) brightness(80%);
  }
}
</style>



// WEBPACK FOOTER //
// src/vue-ext/components/checkbox/index.vue